import React, { useState } from 'react';

const ReciprocalTable = () => {
  const [startNumber, setStartNumber] = useState(1.0);
  const [reciprocalTable, setReciprocalTable] = useState([]);

  const calculateReciprocalTable = () => {
    const table = [];
    for (let i = 0; i < 10; i++) {
      const number = parseFloat(startNumber) + i / 10;
      const reciprocalValue = (1 / number).toFixed(4);
      table.push({ number: number.toFixed(1), reciprocalValue });
    }
    setReciprocalTable(table);
  };

  return (
    <div>
      <h2>Reciprocal Table Generator</h2>
      <label htmlFor="startNumber">Enter a starting number (1.0 - 9.9): </label>
      <input
        type="number"
        id="startNumber"
        min="1.0"
        max="9.9"
        step="0.1"
        value={startNumber}
        onChange={(e) => setStartNumber(parseFloat(e.target.value))}
      />
      <button onClick={calculateReciprocalTable}>Generate Table</button>

      {reciprocalTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Number</th>
              <th>Reciprocal Value</th>
            </tr>
          </thead>
          <tbody>
            {reciprocalTable.map((row, index) => (
              <tr key={index}>
                <td>{row.number}</td>
                <td>{row.reciprocalValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ReciprocalTable;
